import React, { useEffect } from 'react'
import { Header } from '../Core/Header'
import { Footer } from '../Core/Footer'
import { getreviewQuestionApi, submitReview } from '../Services/Operations/ProductAPI'
import { toast } from 'react-toastify'

const QuestionReview = () => {
    const[questions,setQuestions]=React.useState([])
    const[answerSlab,setAnswerSlab]=React.useState(-12)
    const[answer,setAnswer]=React.useState("")

    const fetchQuestions = async ()=>{
        try {
            const response=await getreviewQuestionApi()
            console.log(response);
            setQuestions(response)
            
        } catch (error) {
            console.log("Error fetching questions: ", error);
            
        }
    }

    const answerSubmit = async (questionId)=>{

    let data={
               
  "answers": [
    {
      "questionId": questionId,
      "answer": answer,
      "submittedAt":new Date().toISOString()
    }
  ]
    }

        try {
            const response =await submitReview(data)
            console.log("Answer submitted successfully: ", response);
            toast.success("Answer submitted successfully")
            
            
        } catch (error) {
            console.log("Error submitting answer: ", error);
            
        }finally{
            console.log("Submitting answer for question ID: ", questionId,answer,data);
        setAnswerSlab(-1) 
        }
       
        
    }

    useEffect(() => {
      fetchQuestions()
    }, [])
    

  return (
    <div>
        <Header/>
        <div>
            <div className="container" style={{minHeight:"80vh",paddingTop:"100px"}}>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="text-center my-5">Question Review</h1>
                        <p className="text-center">Here you can review your questions and answers.</p>
                        <div className="table-responsive" style={{maxHeight:"500px",overflowY:"auto"}}>
                            { questions.length > 0 ?questions.map((question, index) =>(
                                <div>
                                    <div key={index} className="border p-3 mb-3">
                                        <h5>Question: {question.questionText}</h5>
                                        <p>Active :{question.active?"YES":"NO"}</p>
                                       {answerSlab!==question.id? <p onClick={()=>{setAnswerSlab(question.id); setAnswer("")}}
                                        style={{cursor:"pointer",padding:"5px",backgroundColor:"#f0f0f0",borderRadius:"5px",width:"fit-content"}} >
                                            Submit Answer</p>:
                                            <p onClick={()=>{setAnswerSlab(-1); setAnswer("")}}
                                        style={{cursor:"pointer",padding:"5px",backgroundColor:"#000000",borderRadius:"5px",width:"fit-content",color:"#ffffff"}} >
                                            cancel</p>}

                                            {answerSlab===question.id &&<div className="row">
                                                <textarea
                                                value={answer}
                                                onChange={(e)=>setAnswer(e.target.value)}
                                                placeholder='Submit your answer here...'
                                                style={{width:"100%",height:"100px",borderRadius:"5px",padding:"10px",outline:"none",border:"1px solid #ccc"}}
                                                >

                                                </textarea>
                                                <button className="btn btn-primary mt-2"
                                                onClick={()=>answerSubmit(question.id)}
                                                >Submit</button>
                                            </div>}
                                    </div>
                                </div>
                            )):"No questions available."}
                        </div>
                            
                    </div>
                </div>
            </div>
        </div>

        <Footer/>

    </div>
  )
}

export default QuestionReview